export default {
  name: "setting-template"
};